var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary"}},[_c('div',{staticClass:"feather"},[_c('img',{staticClass:"feather-img",attrs:{"src":require("@/assets/images/iconadd.png")}}),_c('div',[_c('div',[_vm._t("title")],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }